import { Icon, IIconProps } from 'native-base';
import { Path, Circle } from 'react-native-svg';

const WarningIcon = ({ size = 'sm', ...props }: IIconProps) => {
  return (
    <Icon viewBox="0 0 24 24" size={size} fill="none" {...props}>
      <Path d="M12 4v10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" fill="none" />
      <Circle cx="12" cy="19" r="0.5" fill="currentColor" />
    </Icon>
  );
};

export default WarningIcon;
